/**
 * 问卷管理模块 - 枚举定义
 */

// ==================== 题目类型枚举 ====================
/**
 * 题目类型枚举
 */
export const QuestionTypeEnum = {
  SINGLE_CHOICE: 'SINGLE_CHOICE',  // 单选题
  MULTI_CHOICE: 'MULTI_CHOICE',    // 多选题
  TEXT: 'TEXT',                     // 填空题
  DATE: 'DATE',                     // 日期选择
  FILE_UPLOAD: 'FILE_UPLOAD',       // 附件上传
  TABLE: 'TABLE',                   // 表格问题
  CASCADE: 'CASCADE',               // 级联问题
}

/**
 * 题目类型文案映射
 */
export const QuestionTypeTextEnum = {
  [QuestionTypeEnum.SINGLE_CHOICE]: '单选题',
  [QuestionTypeEnum.MULTI_CHOICE]: '多选题',
  [QuestionTypeEnum.TEXT]: '填空题',
  [QuestionTypeEnum.DATE]: '日期选择',
  [QuestionTypeEnum.FILE_UPLOAD]: '附件上传',
  [QuestionTypeEnum.TABLE]: '表格问题',
  [QuestionTypeEnum.CASCADE]: '级联问题',
}

/**
 * 题目类型选项数组
 */
export const QuestionTypeOptions = [
  { value: QuestionTypeEnum.SINGLE_CHOICE, text: QuestionTypeTextEnum[QuestionTypeEnum.SINGLE_CHOICE] },
  { value: QuestionTypeEnum.MULTI_CHOICE, text: QuestionTypeTextEnum[QuestionTypeEnum.MULTI_CHOICE] },
  { value: QuestionTypeEnum.TEXT, text: QuestionTypeTextEnum[QuestionTypeEnum.TEXT] },
  { value: QuestionTypeEnum.DATE, text: QuestionTypeTextEnum[QuestionTypeEnum.DATE] },
  { value: QuestionTypeEnum.FILE_UPLOAD, text: QuestionTypeTextEnum[QuestionTypeEnum.FILE_UPLOAD] },
  { value: QuestionTypeEnum.TABLE, text: QuestionTypeTextEnum[QuestionTypeEnum.TABLE] },
  { value: QuestionTypeEnum.CASCADE, text: QuestionTypeTextEnum[QuestionTypeEnum.CASCADE] },
]

// ==================== 填空题输入类型枚举 ====================
/**
 * 填空题输入类型枚举
 */
export const InputTypeEnum = {
  TEXT: 'TEXT',         // 单行文本
  TEXTAREA: 'TEXTAREA', // 多行文本
}

/**
 * 填空题输入类型文案映射
 */
export const InputTypeTextEnum = {
  [InputTypeEnum.TEXT]: '单行文本',
  [InputTypeEnum.TEXTAREA]: '多行文本',
}

// ==================== 填空题输入规则枚举 ====================
/**
 * 填空题输入规则枚举
 */
export const InputRuleEnum = {
  NONE: 'NONE',         // 无限制
  NUMBER_ONLY: 'NUMBER_ONLY', // 只允许数字
}

/**
 * 填空题输入规则文案映射
 */
export const InputRuleTextEnum = {
  [InputRuleEnum.NONE]: '无限制',
  [InputRuleEnum.NUMBER_ONLY]: '只允许数字',
}

/**
 * 填空题输入规则选项数组
 */
export const InputRuleOptions = [
  { value: InputRuleEnum.NONE, text: InputRuleTextEnum[InputRuleEnum.NONE] },
  { value: InputRuleEnum.NUMBER_ONLY, text: InputRuleTextEnum[InputRuleEnum.NUMBER_ONLY] },
]

// ==================== 问卷状态枚举 ====================
/**
 * 问卷状态枚举
 */
export const QuestionnaireStatusEnum = {
  NOT_STARTED: 'not_started',  // 未开始
  ONGOING: 'ongoing',           // 进行中
  ENDED: 'ended',               // 已结束
}

/**
 * 问卷状态文案映射
 */
export const QuestionnaireStatusTextEnum = {
  [QuestionnaireStatusEnum.NOT_STARTED]: '未开始',
  [QuestionnaireStatusEnum.ONGOING]: '进行中',
  [QuestionnaireStatusEnum.ENDED]: '已结束',
}

/**
 * 问卷状态选项数组
 */
export const QuestionnaireStatusOptions = [
  { value: QuestionnaireStatusEnum.NOT_STARTED, text: QuestionnaireStatusTextEnum[QuestionnaireStatusEnum.NOT_STARTED] },
  { value: QuestionnaireStatusEnum.ONGOING, text: QuestionnaireStatusTextEnum[QuestionnaireStatusEnum.ONGOING] },
  { value: QuestionnaireStatusEnum.ENDED, text: QuestionnaireStatusTextEnum[QuestionnaireStatusEnum.ENDED] },
]

// ==================== 级联问题枚举 ====================
/**
 * 级联数据源类型 — 选项由后端接口提供
 */
export const CascadeQuestionTypeEnum = {}

/**
 * 级联回答层级类型 — 选项由后端接口提供，根据 cascadeQuestionType 动态获取
 */
export const CascadeAnswerTypeEnum = {}

/**
 * 附件上传允许的文件类型
 */
export const FileAcceptTypes = ['excel', 'ppt', 'pdf', 'zip', 'word']

/**
 * 附件上传允许的文件后缀映射
 */
export const FileAcceptExtensionMap = {
  excel: '.xlsx,.xls',
  ppt: '.pptx,.ppt',
  pdf: '.pdf',
  zip: '.zip',
  word: '.docx,.doc',
}

/**
 * 附件上传文件大小上限（MB）
 */
export const FileMaxSizeLimit = 120
